import { Tooltip } from "@mui/material";
import { LAUNCH_STATUS_HINTS } from "../../utils/constants/AdLaunch";
import StatusChip from "../common/StatusChip";

const LAUNCH_STATUS_CONFIG = {
  ready: { label: "Ready", chip: "launch_pending" },
  scheduled: { label: "Scheduled", chip: "launch_queued" },
  queued: { label: "Queued", chip: "launch_queued" },
  processing: { label: "Processing", chip: "launch_processing" },
  meta_scheduled: { label: "Launch scheduled", chip: "launch_scheduled" },
  success: { label: "Success", chip: "launch_success" },
  failed: { label: "Launch failed", chip: "launch_failed" },
  schedule_failed: { label: "Schedule failed", chip: "schedule_failed" },
  cancelled: { label: "Cancelled", chip: "cancelled" },
};

/** Launch status chip; hovering it explains the status, or shows `title` when given. */
const LaunchStatusChip = ({ status, title }) => {
  const key = (status || "").toLowerCase();
  const config = LAUNCH_STATUS_CONFIG[key];
  return (
    <Tooltip arrow title={title ?? LAUNCH_STATUS_HINTS[key] ?? ""}>
      <span>
        <StatusChip
          subtle
          status={config?.chip ?? "default"}
          label={config?.label ?? status ?? "—"}
        />
      </span>
    </Tooltip>
  );
};

export default LaunchStatusChip;
